import graphqlClient from "@/GQLClient";
import { type InstitutionBasic } from "@/extendedTypes";
import {
  GetDepartmentsByInstitutionIdDocument,
  InstitutionQueryDocument,
} from "@/graphql/generated-types";

const getInstitution = async (id: string) => {
  try {
    const response = await graphqlClient.query({
      query: InstitutionQueryDocument,
      variables: {
        ids: [id],
      },
    });

    if (!response.data?.institutions?.get) {
      throw new Error("An error occurred when getting data");
    }

    return response.data.institutions.get[0] as InstitutionBasic;
  } catch (error) {
    // oxlint-disable-next-line no-console
    console.error("getInstitution error", error);
  }
};

const getAll = async () => {
  const response = await graphqlClient.query({
    query: InstitutionQueryDocument,
    variables: {
      ids: [],
    },
  });

  if (!response.data?.institutions?.get) {
    throw new Error("An error occurred when getting data");
  }

  return response.data.institutions.get as InstitutionBasic[];
};

const getDepartmentsByInstitutionId = async (institutionId: string) => {
  const response = await graphqlClient.query({
    query: GetDepartmentsByInstitutionIdDocument,
    variables: {
      ids: [institutionId],
    },
  });

  if (
    !response.data?.institutions?.get ||
    response.data.institutions.get.length === 0
  ) {
    throw new Error("An error occurred when getting data");
  }

  const [institution] = response.data.institutions.get;

  return institution.departments || [];
};

export default {
  getInstitution,
  getAll,
  getDepartmentsByInstitutionId,
};
